import type {ListServicesSearchInput} from "./list-services.schema";

import {listServices} from "@project/sdk/engineering";
import {ListServicesResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {serviceKeys} from "../../../service-keys";

import {listServicesSearchSchema} from "./list-services.schema";

export function listServicesQueryOptions(rawInput: ListServicesSearchInput) {
  const params = listServicesSearchSchema.parse(rawInput);

  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: serviceKeys.list(params),
    queryFn: async ({signal}) => ListServicesResponse.parse(await listServices(params, {signal})),
  });
}
